import React from 'react';
import Portfolio from './portfolio';
import ClarityComponent from './components/Clarity';

function App() {
  return (
    <div className="App">
      <ClarityComponent />
      <Portfolio />
    </div>
  );
}

export default App;
